export default __webpack_public_path__ + "static/media/forest-stream.5b71a613.jpeg";